<template>
    <div class="admin-address-list">
        <el-input
            placeholder="Search"
            v-model="keyword"
            clearable
            @change="loadData"
            prefix-icon="el-icon-search"
        ></el-input>
        <el-table
            :data="tableData"
            style="width: 100%"
            stripe
            v-loading="processing"
            :row-class-name="tableRowClassName"
            @row-click="onDetailClick"
        >
            <el-table-column prop="id" label="ID" width="50" fixed></el-table-column>
            <el-table-column prop="display_name" label="Name"  fixed></el-table-column>
            <el-table-column prop="asset_name" label="Asset" width="180"  fixed></el-table-column>
            <el-table-column prop="address" label="ADDRESS" ></el-table-column>
            <el-table-column label="Created">
                <template slot-scope="scope">{{scope.row.created | formatDate}}</template>
            </el-table-column>
        </el-table>
        <AddressDetail :show="showDetail" :onClose="onDetailClose" :data="selectedData" />
    </div>
</template>

<script>
import AddressDetail from "@/components/AddressDetail";
import { mapActions } from "vuex";

export default {
    name: "AdminAddressList",
    props: {
        authenticate_id: {type: Number, default: null}
    },
    components: {
        AddressDetail
    },
    data() {
        return {
            keyword: "",
            tableData: [],
            processing: false,
            showDetail: false,
            selectedData: null,
            total: 0,
            skip: 0
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...mapActions(["request", "getError"]),
        loadData({ skip = 0, limit = 100 } = {}) {
            let ctrl = this;
            ctrl.processing = true;
            let endpoint = "addressbook";
            let params = { limit, skip };
            if(ctrl.keyword.trim().length > 0) {

                params.where = `(label LIKE '%${ctrl.keyword.trim()}%' OR address LIKE '%${ctrl.keyword.trim()}%')`;
                ctrl.tableData = [];
                ctrl.skip = 0;
                ctrl.total = 0;
            }
            ctrl.request({
                method: "GET",
                endpoint,
                params
            })
                .then(({ data = {} }) => {
                    if(skip == 0) {
                        ctrl.tableData = [];
                    }
                    ctrl.total = data.total;
                    ctrl.skip += data.results.length;
                    ctrl.tableData = [...ctrl.tableData, ...data.results];
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "Get Address Failed",
                        message: "Unknown Error"
                    }).then(this.$notify)
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                        ctrl.$forceUpdate();
                    }, 500);
                });
        },
        tableRowClassName({ row }) {
            if (!row.enabled) {
                return "disabled-row";
            }
            return "enabled-row";
        },
        onDetailClick(row) {
            this.showDetail = true;
            this.selectedData = row;
        },
        onDetailClose(reload = false) {
            this.showDetail = false;
            this.selectedData = null;
            if (reload == true) {
                this.loadData();
            }
        },
    }
};
</script>
<style scoped>
.user-address {
    flex: 1;
    padding: 16px;
}

.user-address h2 {
    color: #555;
}
</style>